// PageNotFound.jsx
// TK 04/03/2022

// Packages, dependencies, and shared libraries
import React from "react";
import { openInNewTab } from "../sharedFunctions";

// React Components
import PlantBioPageHeader from "../BioPage/Header/BioPageHeader";
import Error from "./Error";

// Constants
import * as constants from "../constants";

/*******************************************************************************
 * @func PageNotFound (React Component)
 * The component that should be displayed whenever the url does not resolve to
 * any of the other pages
 *
 * @param None
 * @return JSX Element
 *
 * @notes None
 *
 ******************************************************************************/
const PageNotFound = () => {
  return (
    <React.Fragment>
      <PlantBioPageHeader />
      <Error error={"We couldn't find that page — it must have been pruned."} />
      <div className="font-global mt-6 mb-8 text-center text-leaf-brown-soft text-sm">
        <div className="line"></div>
        <div>
          Questions?{" "}
          <span
            className="underline cursor-pointer hover:text-leaf-brown transition-colors"
            onClick={() => openInNewTab(constants.INSTAGRAM_URL)}
          >
            DM us on Instagram
          </span>
        </div>
      </div>
    </React.Fragment>
  );
}; // End PageNotFound

export default PageNotFound;
